<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="atividades vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('agendas') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('crm') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('agendas') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <!-- <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'new-venda-atividade',
                                    })
                                "
                            >
                                {{ $t('adicionar') }}
                            </button> -->
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-2 is-variable is-multiline control-bar mt-0">
                        <!-- margin-top 0; pq o columns por padrão tem margem negativa -->
                        <!-- PESQUISA -->
                        <div class="column">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- TIPO ATIVIDADE -->
                        <div class="column is-one-quarter is-flex is-flex-vbottom">
                            <vss-select
                                class="is-100"
                                label="descricao"
                                :value="tipoAtividade"
                                :options="tiposAtividades"
                                :selectHeight="40"
                                :loading="tiposLoading"
                                @input="updateTipoAtividade"
                                @search="carregarTipos"
                                title="tipo-agenda"
                                multiple
                                searchable
                                clearable
                            >
                                <template #multiple-selected="{ selected }">
                                    {{ $t('tipo') }} ({{
                                        selected && selected.length > 0
                                            ? selected.length
                                            : $t('todos')
                                    }})
                                </template>
                            </vss-select>
                        </div>

                        <!-- USUÁRIO -->
                        <div class="column is-one-quarter is-flex is-flex-vbottom">
                            <vss-select
                                class="is-100"
                                label="nome"
                                :value="usuariosSelecionados"
                                :options="usuarios"
                                :selectHeight="40"
                                title="colaborador"
                                :loading="usuariosLoading"
                                @search="carregarColaboradores"
                                @input="updateColaborador"
                                multiple
                                searchable
                                clearable
                            >
                                <template #multiple-selected="{ selected }">
                                    {{ $t('colaborador') }} ({{
                                        selected && selected.length > 0
                                            ? selected.length
                                            : $t('todos')
                                    }})
                                </template>
                            </vss-select>
                        </div>

                        <!-- FILTROS DE DATA -->
                        <div class="column is-full is-flex date-group">
                            <b-field class="date-opts">
                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="pl"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('PLANEJADO') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="at"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('ATRASADO') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="h"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('hoje') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="a"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('amanha') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="s"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('esta-semana') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="ps"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('proxima-semana') }}</span>
                                </b-radio-button>

                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="c"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('periodo') }}</span>
                                </b-radio-button>
                                <b-radio-button
                                    v-model="tipo"
                                    size="is-small"
                                    native-value="t"
                                    :disabled="isLoading"
                                >
                                    <span>{{ $t('todos') }}</span>
                                </b-radio-button>
                            </b-field>
                            <div class="periodo-custom is-flex" v-if="tipo == 'c'">
                                <div class="columns is-variables">
                                    <div class="column is-1">
                                        <span></span>
                                    </div>
                                    <div class="column is-4">
                                        <verified-date-picker
                                            dateType="startDate"
                                            v-model="datainicial"
                                            :endDate="datafinal"
                                            title="data-inicial"
                                            @input="changeStartDate"
                                        />
                                    </div>
                                    <div class="column is-4">
                                        <verified-date-picker
                                            dateType="endDate"
                                            v-model="datafinal"
                                            :startDate="datainicial"
                                            title="data-final"
                                            :addDateYears="2"
                                            @input="changeEndDate"
                                        />
                                    </div>
                                    <div class="column is-2">
                                        <button
                                            class="save-btn botao-acao"
                                            type="button"
                                            @click="pesquisaData"
                                        >
                                            {{ $t('pesquisar') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- LISTAGEM -->
                    <div class="atividades-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="atividades ? atividades : []"
                            @sort="updateSort"
                            backend-sorting
                            backend-pagination
                        >
                            <template v-for="(f, i) in fields">
                                <b-table-column
                                    :key="i"
                                    :field="f.key"
                                    :label="f.label"
                                    :sortable="f.sortable"
                                    :width="f.width"
                                    :centered="f.centered"
                                    :class="{ 'td-center': f.vcenter }"
                                >
                                    <template v-slot:header="{ column }">
                                        <span v-if="column.label == 'datafim'">
                                            {{ $t('fim') }}
                                            <div class="table-sep" />
                                            {{ $t('executado-em') }}
                                        </span>
                                        <span v-else-if="column.label == 'colaborador'">
                                            {{ $t('colaborador') }}
                                            <div class="table-sep" />
                                            {{ $t('cliente') }}
                                        </span>
                                        <span v-else>
                                            {{ column.label ? $t(column.label) : '' }}
                                        </span>
                                    </template>

                                    <template v-slot="props">
                                        <div v-if="f.key == 'excluir'" class="no-strike">
                                            <b-field :addons="false">
                                                <b-button
                                                    v-if="
                                                        props.row.permitirRemover &&
                                                        permissao.delete
                                                    "
                                                    type="is-danger"
                                                    icon-right="delete"
                                                    @click="promptForDelete(props.row)"
                                                    v-tippy 
                                                    :title="$t('excluir')"
                                                />
                                                <b-button
                                                    v-if="permissao.update && !props.row.dataHoraFinalizado"
                                                    class="mt-2"
                                                    :class="{
                                                        strike: !!props.row.dataHoraFinalizado,
                                                    }"
                                                    type="is-success"
                                                    icon-right="check"
                                                    @click="promptForCompletion(props.row)"
                                                    v-tippy 
                                                    :title="$t('finalizar-agenda')"
                                                />
                                            </b-field>
                                        </div>
                                        <div v-else-if="f.key == 'status'" class="no-strike">
                                            <b-tag :type="statusColor(props.row.status)">
                                                {{ $t(props.row[f.key]) }}
                                            </b-tag>
                                        </div>
                                        <div v-else-if="f.key == 'datainicio'">
                                            {{
                                                props.row.datainicio
                                                    ? $moment(props.row.datainicio).format('L LT')
                                                    : '—'
                                            }}
                                        </div>
                                        <div v-else-if="f.key == 'datafim'">
                                            {{
                                                props.row.datafim
                                                    ? $moment(props.row.datafim).format('L LT')
                                                    : '—'
                                            }}
                                            <div class="table-sep" />
                                            {{
                                                props.row.dataHoraFinalizado
                                                    ? $moment(props.row.dataHoraFinalizado).format(
                                                          'L LT'
                                                      )
                                                    : '—'
                                            }}
                                        </div>
                                        <div v-else-if="f.key == 'colaborador'">
                                            <span class="has-text-weight-bold">{{
                                                props.row.colaborador
                                                    ? props.row.colaborador.nome
                                                    : ''
                                            }}</span>
                                            <div class="table-sep" />
                                            <span v-if="props.row.cliente">
                                                {{ props.row.cliente.rsocial }}
                                            </span>
                                        </div>
                                        <div
                                            v-else-if="f.key == 'titulo'"
                                            class="has-text-weight-bold"
                                        >
                                            <router-link
                                                :to="{
                                                    name: 'edit-venda-atividade',
                                                    params: { id: props.row.uuid },
                                                }"
                                            >
                                                {{ props.row.titulo }}
                                            </router-link>
                                        </div>
                                        <div v-else-if="f.key == 'tipo'">
                                            {{ props.row.tipo ? props.row.tipo.descricao : '' }}
                                        </div>
                                        <div v-else>
                                            {{ props.row[f.key] }}
                                        </div>
                                    </template>
                                </b-table-column>
                            </template>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import AgendaAtividadeService from '@/services/AgendaAtividadeService';
import ColaboradorService from '@/services/ColaboradorService';
import TipoAgendaAtividadeService from '@/services/TipoAgendaAtividadeService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('venda-atividade') && to.name != 'venda-atividades') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            atividades: [],
            service: new AgendaAtividadeService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            tipoService: new TipoAgendaAtividadeService(this.$http, this.$router),
            fields: [
                {
                    key: 'status',
                    label: 'status',
                    sortable: false,
                    width: 105,
                    centered: true,
                    vcenter: true,
                },
                { key: 'colaborador', label: 'colaborador', sortable: true },
                { key: 'titulo', label: 'titulo', sortable: true },
                { key: 'tipo', label: 'tipo', sortable: true, width: 150 },
                //@71446 - Acrescido 5px no width de data inicio
                {
                    key: 'datainicio',
                    label: 'inicio',
                    sortable: true,
                    width: 115,
                },
                { key: 'datafim', label: 'fim', sortable: true, width: 160 },
                {
                    key: 'excluir',
                    label: '',
                    sortable: false,
                    width: 50,
                    centered: true,
                    vcenter: true,
                },
            ],
            isLoading: false,
            isEmpty: false,
            query: '',
            tipo: 't',
            tipoAtividade: [],
            tiposAtividades: [],
            tiposLoading: true,
            usuarios: [],
            usuariosSelecionados: [],
            usuariosLoading: true,
            filtros: {
                usuarios: [],
                tiposAtividade: [],
                status: '',
                ini: null,
                fim: null,
            },
            filtrosInit: {
                usuarios: [],
                tiposAtividade: [],
                status: '',
                ini: null,
                fim: null,
            },
            sort: 'datahorainc',
            order: 'desc',
            datainicial: new Date(this.$moment().subtract(30, 'days')),
            datafinal: new Date(),
            delete: null,
            permissao: {},
            filtroperiodo: {
                ini: null,
                fim: null,
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isStarted: false,
        };
    },
    watch: {
        usuariosLoading(val) {
            if (!val && !this.tiposLoading) this.carregarDados();
        },
        tiposLoading(val) {
            if (!val && !this.usuariosLoading) this.carregarDados();
        },
        tipo() {
            this.changeTipo();
        },
    },
    created() {
        if (
            this.$route.name.includes('venda-atividade') &&
            this.$route.name != 'venda-atividades'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        // Seleciona o valor na posição do array de opções de paginação
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'venda-atividades');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'venda-atividades' },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarColaboradores('');
        // this.carregarTipos('');
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            let filtro = {
                atividades: this.filtros.tiposAtividade,
                usuarios: this.filtros.usuarios ? this.filtros.usuarios : [],
                inicio: this.filtros.ini ? this.filtros.ini : null,
                fim: this.filtros.fim ? this.filtros.fim : null,
                status: this.filtros.status,
            };
            this.isLoading = true;
            this.service
                .findAll(
                    filtro,
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.query
                )
                .then((r) => {
                    this.atividades = r.content;
                    this.pagination.totalRows = r.totalElements;
                    this.isEmpty = this.atividades.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar agendas.');
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        carregarColaboradores(q) {
            // this.usuariosLoading = true;
            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.usuarios = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de colaboradores. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.usuariosLoading = false;
                });
        },
        carregarTipos(q) {
            // this.tiposLoading = true;
            this.tipoService
                .findAll('descricao', 'asc', 0, 20, 1, q)
                .then((r) => {
                    this.tiposAtividades = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de tipos de agendas. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.tiposLoading = false;
                });
        },
        onSearch(value) {
            this.query = this.removeAcentos(value);
            this.carregarDados();
        },
        statusColor(s) {
            switch (s) {
                case 'REALIZADO':
                    return 'is-success';
                case 'ATRASADO':
                    return 'is-warning';
                default:
                    return 'is-info';
            }
        },
        pesquisaData() {
            this.filtros.status = 'PERIODO';
            this.filtros.ini = this.datainicial
                ? this.$moment(this.datainicial).format('YYYY-MM-DD')
                : null;
            this.filtros.fim = this.datafinal
                ? this.$moment(this.datafinal).format('YYYY-MM-DD')
                : null;

            this.carregarDados();
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            this.datainicial = date;
        },
        changeEndDate(date) {
            this.datafinal = date;
        },
        updateColaborador(c) {
            this.usuariosSelecionados = c;
            this.filtros.usuarios = c.map((e) => e.id);
            this.carregarDados();
        },
        updateTipoAtividade(t) {
            this.tipoAtividade = t;
            this.filtros.tiposAtividade = t.map((e) => e.id);
            this.carregarDados();
        },
        updateSort(sort, order) {
            this.sort = sort;
            this.order = order;
            this.carregarDados();
        },
        promptForDelete(row) {
            this.delete = row;

            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n:  row.titulo }),
                onConfirm: this.excluir,
                onCancel: this.removePrompt,
            });
        },
        promptForCompletion(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t('msg-confirm-finalizar-atividade-n', { n: row.titulo }),
                onConfirm: this.finalizar,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        excluir() {
            let row = this.delete;
            this.isLoading = true;
            this.service
                .delete(row.uuid)
                .then((r) => {
                    this.carregarDados();
                    this.$root.showMessage('success', 'msg-agenda-delete-success');
                })
                .catch((e) => {
                    console.error('Erro ao excluir agenda.', e);

                    if (e.body && e.body.message && e.body.message.startsWith('msg-')) {
                        this.$root.showMessage('error', e.body.message);
                    } else {
                        this.$root.showMessage('error', 'msg-agenda-delete-error');
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        finalizar() {
            let row = this.delete;
            this.isLoading = true;
            this.service
                .execute(row.uuid)
                .then((r) => {
                    this.carregarDados();
                    this.$root.showMessage('success', 'msg-agenda-executada-success');
                })
                .catch((e) => {
                    console.error('Erro ao executar tarefa.', e);
                    this.$root.showMessage('error', 'msg-agenda-executada-error');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        changeTipo() {
            switch (this.tipo) {
                case 'pl':
                    this.filtros.status = 'PLANEJADO';
                    this.filtros.ini = null;
                    this.filtros.fim = null;
                    break;
                case 'at':
                    this.filtros.status = 'ATRASADO';
                    this.filtros.ini = null;
                    this.filtros.fim = null;
                    break;
                case 'h':
                    this.filtros.status = 'HOJE';
                    this.filtros.ini = this.$moment();
                    this.filtros.fim = this.$moment();
                    break;
                case 'a':
                    this.filtros.status = 'AMANHA';
                    this.filtros.ini = this.$moment().add(1, 'day');
                    this.filtros.fim = this.$moment().add(1, 'day');
                    break;
                case 's':
                    this.filtros.status = 'ESTASEMANA';
                    this.filtros.ini = this.$moment().startOf('week');
                    this.filtros.fim = this.$moment().endOf('week');
                    break;
                case 'ps':
                    this.filtros.status = 'PROXIMASEMANA';
                    this.filtros.ini = this.$moment().add(1, 'week').startOf('week');
                    this.filtros.fim = this.$moment().add(1, 'week').endOf('week');
                    break;
                case 'c':
                    this.filtros.status = 'PERIODO';

                    this.filtroperiodo.ini = this.$moment(this.datainicial).format('YYYY-MM-DD');
                    this.filtroperiodo.fim = this.$moment(this.datafinal).format('YYYY-MM-DD');

                    this.filtros.ini = this.filtroperiodo.ini;
                    this.filtros.fim = this.filtroperiodo.fim;

                    break;
                case 't':
                    this.filtros.status = '';
                    this.filtros = this.filtros
                        ? this.filtros
                        : Object.assign({}, this.filtrosInit);
                    this.filtros.ini = null;
                    this.filtros.fim = null;
                    break;
                default:
                    this.filtros = Object.assign({}, this.filtrosInit);
                    break;
            }
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    h1.title {
        padding-top: 0px;
        margin-bottom: 0 !important;
    }

    .botao-acao {
        margin-top: 30px;
        width: 100%;
        height: 40px;
    }

    .page {
        position: relative;
        padding-left: 0;

        .control-bar {
            margin-bottom: 0;

            .column:first-child {
                padding-bottom: 0.25rem;
            }

            .column:last-child {
                padding-top: 0.25rem;
            }

            .date-opts {
                margin-bottom: 0.5rem !important;
            }

            .date-group {
                justify-content: center;
                flex-wrap: wrap;
            }

            .periodo-custom {
                width: 100%;
                justify-content: center;
                align-items: center;

                .periodo-input {
                    margin: 0 1rem;
                    padding: 0.2rem;
                    height: 27px;
                    width: 100px;
                    font-size: 0.75rem;
                }
            }

            button.btn-search {
                height: 27px;
                font-size: 12px;
                color: $sovis-white;
                @include gradient-button();
            }
        }

        td.strike > div:not(.no-strike) {
            text-decoration: line-through;
        }

        .sub-text {
            text-transform: uppercase;
            font-size: 12px;
        }
    }
}
</style>
